import gql from "graphql-tag";

export const getNoticias = gql`
  query getNoticias(
    $page: Int!
    $rowsPerPage: Int!
    $idNoticia: Int
    $nombre: String
    $idPrograma: Int
    $fechaInicio: Date
    $fechaFin: Date
    $idUsuarioCreador: Int
    $order: Order!
    $orderBy: NoticiaColumn!
    $IsActive: Boolean
  ) {
    getNoticias(
      noticiasLike: {
        idNoticia: $idNoticia
        nombre: $nombre
        idPrograma: $idPrograma
        idUsuarioCreador: $idUsuarioCreador
        IsActive: $IsActive
      }
      noticiasRange: {
        fechaInicio: { min: $fechaInicio }
        fechaFin: { max: $fechaFin }
      }
      noticiasOrder: { column: $orderBy, order: $order }
      pagina: { numeroPagina: $page, cantidadPorPagina: $rowsPerPage }
    ) {
      itemsPagina {
        idNoticia
        nombre
        template
        fechaInicio
        fechaFin
        fechaCreacion
        limiteDiasVisualizacion
        frecuenciaDiaria
        requiereLogin
        usuarioCreador {
          idUsuario
          username
        }
        programa {
          idPrograma
          nombre
        }
        IsActive
        segmentos {
          segmento {
            idSegmento
            nombre
          }
        }
      }
      infoPagina {
        total
        numeroPagina
        cantidadPaginas
      }
    }
  }
`;

export const getNoticiaById = gql`
  query getNoticia($idNoticia: Int!) {
    getNoticia(idNoticia: $idNoticia) {
      idNoticia
      nombre
      template
      fechaInicio
      fechaFin
      fechaCreacion
      limiteDiasVisualizacion
      frecuenciaDiaria
      requiereLogin
      usuarioCreador {
        idUsuario
        username
      }
      programa {
        idPrograma
        nombre
      }
      IsActive
      segmentos {
        segmento {
          idSegmento
        }
        secciones
      }
    }
  }
`;

export const createNoticia = gql`
  mutation createNoticia($noticia: NoticiaInput!) {
    createNoticia(noticia: $noticia) {
      idNoticia
      nombre
      template
      fechaInicio
      fechaFin
      fechaCreacion
      limiteDiasVisualizacion
      frecuenciaDiaria
      requiereLogin
      usuarioCreador {
        idUsuario
        username
      }
      programa {
        idPrograma
        nombre
      }
      IsActive
      segmentos {
        segmento {
          idSegmento
        }
        secciones
      }
    }
  }
`;

export const updateNoticia = gql`
  mutation updateNoticia($noticia: NoticiaInput!) {
    updateNoticia(noticia: $noticia) {
      idNoticia
      nombre
      template
      fechaInicio
      fechaFin
      fechaCreacion
      limiteDiasVisualizacion
      frecuenciaDiaria
      requiereLogin
      usuarioCreador {
        idUsuario
        username
      }
      programa {
        idPrograma
        nombre
      }
      IsActive
      segmentos {
        segmento {
          idSegmento
        }
        secciones
      }
    }
  }
`;

export const removeNoticia = gql`
  mutation removeNoticia($idNoticia: Int!) {
    removeNoticia(idNoticia: $idNoticia)
  }
`;

export const bulkNoticiasViews = gql`
  mutation bulkNoticiasViews($noticiaKey: NoticiaKey!) {
    bulkNoticiasViews(noticiaKey: $noticiaKey)
  }
`;

export default {
  queries: {
    getNoticias,
    getNoticiaById
  },
  mutations: {
    createNoticia,
    updateNoticia,
    removeNoticia,
    bulkNoticiasViews
  }
};
